export const APPMessages = {
    LoggedInLevel: 'LoggedInLevel',
    CurrentLanguage: 'CurrentLanguage',
};

export const PostAppMessage = (key, value) => {
    if (window.ywAppMessage?.postMessage) {
        window.ywAppMessage.postMessage(`${key}:${value}`);
    }
    if (window.ReactNativeWebView?.postMessage) {
        window.ReactNativeWebView.postMessage(`${key}:${value}`);
    }
};
